import "../styles/ShimmerStyles.css"
const ShimmerLoader = () => {
  return (
    <div className="OverallProgressListPending-item shimmerPop">
      <div className="shimmerPop-text"></div>
      <div className="shimmerPop-button"></div>
    </div>
  );
};
export default ShimmerLoader;
